<template>
  <ModernModalLayout :title="title" :watch-for="data">
    <v-form>
      <v-text-field
        v-model="data.innerValue"
        v-bind="{ placeholder }"
        outlined
        dense
        :error-messages="getValidationErrors('data.innerValue')"
        @input="validate"
      />
    </v-form>

    <template #actions:append>
      <v-btn
        class="px-10"
        depressed
        color="primary"
        :disabled="$v.$invalid || notChanged"
        :loading="$wait('onSubmit')"
        @click="onSubmit"
      >
        Сохранить
      </v-btn>
    </template>
  </ModernModalLayout>
</template>

<script>
import ModernModalLayout from '../layouts/ModernModalLayout.vue';
import validationMixin from '@/utils/validation';
import { maxLength } from 'vuelidate/lib/validators';
import waitable from '@/utils/mixins/waitable';

export default {
  components: {
    ModernModalLayout,
  },
  mixins: [validationMixin, waitable],
  props: {
    title: String,
    value: String,
    placeholder: String,
    action: Function,
  },
  data() {
    return {
      data: {
        innerValue: this.value,
      },
    };
  },
  validations() {
    return {
      data: {
        innerValue: {
          maxSymbolsLength: maxLength(500),
        },
      },
    };
  },

  computed: {
    notChanged() {
      return this.value === this.data.innerValue;
    },
  },

  methods: {
    validate() {
      this.$v.$touch();
    },
    async onSubmit() {
      await this.$loading(this.action(this.data.innerValue), 'onSubmit');

      this.$emit('close');
    },
  },
};
</script>
